/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { MyProfileDetails } from "./MyProfileDetails";
import {
  MyProfileDetailsFromJSON,
  MyProfileDetailsFromJSONTyped,
  MyProfileDetailsToJSON,
  MyProfileDetailsToJSONTyped,
} from "./MyProfileDetails";

/**
 * Response for the self-service "My Profile" page. A signed-in admin who isn't a team member is a normal, expected state (not an error), so we always return 200: \[inDirectory\] is false and \[profile\] is null, and the page shows a "missing directory entry" message.
 * @export
 * @interface MyProfileResponse
 */
export interface MyProfileResponse {
  /**
   *
   * @type {boolean}
   * @memberof MyProfileResponse
   */
  inDirectory: boolean;
  /**
   *
   * @type {MyProfileDetails}
   * @memberof MyProfileResponse
   */
  profile?: MyProfileDetails | null;
}

/**
 * Check if a given object implements the MyProfileResponse interface.
 */
export function instanceOfMyProfileResponse(
  value: object,
): value is MyProfileResponse {
  if (!("inDirectory" in value) || value["inDirectory"] === undefined)
    return false;
  return true;
}

export function MyProfileResponseFromJSON(json: any): MyProfileResponse {
  return MyProfileResponseFromJSONTyped(json, false);
}

export function MyProfileResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): MyProfileResponse {
  if (json == null) {
    return json;
  }
  return {
    inDirectory: json["inDirectory"],
    profile:
      json["profile"] == null
        ? undefined
        : MyProfileDetailsFromJSON(json["profile"]),
  };
}

export function MyProfileResponseToJSON(json: any): MyProfileResponse {
  return MyProfileResponseToJSONTyped(json, false);
}

export function MyProfileResponseToJSONTyped(
  value?: MyProfileResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    inDirectory: value["inDirectory"],
    profile: MyProfileDetailsToJSON(value["profile"]),
  };
}
